/* global window, HTMLElement, IntersectionObserver, CustomEvent */

export default class AnchorVisibilityObserver extends HTMLElement {
    connectedCallback() {
        this.setUpIntersectionObserver();
    }

    private getAnchorId() {
        // use querySelector of this
        // because IntersectionObserver's entry has no querySelector method
        return this.querySelector('[data-anchor]')?.id;
    }

    private setUpIntersectionObserver() {
        const options = {
            rootMargin: '0px 0px -400px 0px',
        };

        const intersectionObserver = new IntersectionObserver(
            this.dispatchAnchorIntersectionEvent.bind(this),
            options,
        );

        intersectionObserver.observe(this);
    }

    private dispatchAnchorIntersectionEvent(entries) {
        entries.forEach((entry) => {
            // only fire event if anchor enters the viewport, not on leave
            if (!entry.isIntersecting) return;

            const payload = {
                bubbles: true,
                detail: {
                    anchorId: this.getAnchorId(),
                },
            };

            this.dispatchEvent(new CustomEvent('anchorIntersect', payload));
        });
    }

    public static defineElement(): void {
        if (!window.customElements.get('anchor-visibility-observer')) {
            window.customElements.define('anchor-visibility-observer', AnchorVisibilityObserver);
        }
    }
}
